export default __webpack_public_path__ + "static/media/free-parking-icon.8f734550.svg";